// extracted by mini-css-extract-plugin
export default {"node":"TranslationNodeRichText_node__Yo6rj"};